import { gql } from '@apollo/client';

import { interactiveLessonSectionOverviewFragment } from '../lesson-builder.graphql';
import { interactiveContentStyleBackgroundFragment } from '../styles/styles.graphql';
import { ActivityOutcomesFragment } from '../components/teaching-notes/key-activity-information/activity-outcomes.graphql';

export const GET_PUBLIC_LESSON_ACTIVITIES = gql`
  query GetPublicLessonActivities($input: GetPublicLessonActivitiesInput!) {
    getPublicLessonActivities(input: $input) {
      id
      language
      date
      outcomes {
        ...ActivityOutcomesFragment
      }
      focusQuestion {
        value
      }
      phenomena {
        value
      }
      landscapeImage {
        key
        fileName
        original
        alt
        data {
          flip
        }
        responsive {
          width
          height
          urls {
            url
            quality
          }
        }
      }
      landscapeImageSourceUrl
      styles {
        fontSize
        ...InteractiveContentStyleBackground
      }
      lesson {
        authorId
        slug
        name
        years {
          name
        }
        unit {
          id
          name
        }
        subjects {
          id
          label
          colour
        }
        landscapeImage {
          responsive {
            width
            height
            urls {
              url
              quality
            }
          }
        }
      }
      sectionsOverview {
        ...InteractiveLessonSectionOverview
      }
      status
      version
      hasUnpublishedChanges
      downloadUrl
      printPdfKey
      printPdfKeyPublicToken
      studentPrintables {
        downloadUrl
        previewUrl
      }
      assetKeys {
        print {
          language
          key
          publicToken
        }
        studentPrintables {
          language
          key
          publicToken
        }
      }
      assetDownloadUrls {
        language
        url
      }
      availableTranslations
    }
  }
  ${interactiveLessonSectionOverviewFragment}
  ${interactiveContentStyleBackgroundFragment}
  ${ActivityOutcomesFragment}
`;
